{
  "manager": {
    "audienceCreator": {
      "title": "Audience",
      "include": "Include",
      "exclude": "Exclude"
    },
    "audienceFilterPicker": {
      "filterCategories": "Filter categories",
      "whatAreYouAdding": "What are you adding?",
      "noCategoriesMatch": "No categories match \"{query}\".",
      "allCategories": "All categories",
      "loadError": "Couldn't load {type}. Check your connection and try again.",
      "selectAllRegOps": "Select all {count} reg. ops",
      "noMatches": "No matches.",
      "addGroup": "Add group",
      "excludeTitle": "Exclude someone from this audience",
      "includeTitle": "Include someone in this audience",
      "searchType": "Search {type}",
      "searchAllCategories": "Search all categories"
    },
    "audienceRecipientPreview": {
      "pickWhoToReach": "Pick who you want to reach below.",
      "sendingTo": "Sending to",
      "except": "except",
      "noRecipients": "No recipients selected — all groups are excluded."
    }
  }
}
